// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","textContainer":"Hero_textContainer__TzWL2","image":"Hero_image__zL6bt"};